const buttonTextTermsOfServicePrivacyStyles = {
  termsOfServiceText: {
    textAlign: "center",
    marginTop: "10px",
  },
};

export default buttonTextTermsOfServicePrivacyStyles;
